export const mutations = {
  increment(state) {
    state.counter += 1;
  },
  decrement(state) {
    state.counter = Math.max(0, state.counter - 1);
  },
};
